import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import styles from './styles.module.scss'
import TagItem, { Tag } from '../Tag'

interface Params {
  tags: Tag[],
  previewCount?: number
}

export default function ManyTags({ tags, previewCount = 10 }: Params) {
  const [showAll, setShowAll] = useState<boolean>(false)
  const showedTags = showAll ? tags : tags.slice(0, previewCount)
  const { t } = useTranslation()

  if (tags.length === 0) {
    return null;
  }

  return (<div className={styles.tagList}>
    <div className={styles.list}>
      {showedTags.map(tag => <TagItem key={tag.name} tag={tag} />)}
    </div>
    {tags.length > previewCount && <button type='button' className={styles.showAll} onClick={() => setShowAll(prev => !prev)}>
      {t(showAll ? 'tags.hide' : 'tags.show')}
    </button>}
  </div>)
}
